export default __webpack_public_path__ + "static/media/bghox.7fc0f147.jpg";